export default {"src":"/_next/static/media/vocalist.7f829eda.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};